#!/usr/bin/env node
import { runCli } from '../lib/cli/CliRunner';
runCli(process.cwd(), process.argv);
